<div class="container-fluid">
  <page-header-search
    pageTitleValue="Search"
    placeholderValue="Patient Name or Mobile Number or National ID or Passport ID or Psp Code"
    [isSearchInput]="true"
    (onHeaderSearchSubmit)="onSearchPatients($event)"
    [searchString]="searchValue"
  ></page-header-search>

  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between row">
            <div class="d-flex  align-items-center col-md-8">
              <h3>PSP Patients</h3>
              <button class="btn btn-neutral ml-3 my-2" (click)="addExportRequest()">
                <span class="btn-inner--icon">
                  <i class="ni ni-cloud-download-95"> </i>
                </span>
                <span class="btn-inner--text"> Download as Excel </span>
              </button>
            </div>
            <div class="col-md-2">
              <app-companies-select (companySelected)="onCompanySelected($event)"></app-companies-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ngx-datatable class="material ngx-datatable-custom" [rows]="patientList" [columns]="columns"
      [limit]="searchParams.pageSize" [offset]="searchParams.currentPage-1" columnMode="force" externalPaging="true"
      [count]="totalItems" [scrollbarH]="true" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
      (page)="onChangePage($event)" selectionType="single" (select)="routeToPatientDetails($event)"
      [messages]="messages">
      <ng-template let-row="row" #nationalIdPassportIdRef ngx-datatable-row-detail-template>
        <span class="ng-star-inserted">{{row.patient.nationalId}} {{row.patient.nationalId && row.patient.passportId && ' / '}}
          {{row.patient.passportId}}</span>
      </ng-template>
      <ng-template #subscriptionHistoryTemplate let-row="row" ngx-datatable-cell-template>
        <div [ngClass]="isArabic(row.subscriptionHistory) ? 'rtl-text' : 'ltr-text'">
          {{ row.subscriptionHistory }}
        </div>
      </ng-template>
      <ng-template #previewDocumentRef let-row="row" ngx-datatable-row-detail-template>
        <div>
          <button class="btn btn-success" 
          (click)="onDocumentsButtonClick(row , $event)"
          (dblclick)="onDocumentsButtonClick(row, $event)"
          [disabled]="!hasDocuments(row)">
          Preview</button>
        </div>
      </ng-template>

    </ngx-datatable>
  </div>
</div>

<ngx-spinner></ngx-spinner>
